import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DocumentArrowDownIcon, XMarkIcon } from "@heroicons/react/24/outline";
import React from "react";
import { typeFile } from "../../function";

const FileCard = ({ item, deleteDocument = () => {}, userdetails }) => {
  const fileTypeLabel = item?.type
    ? item.type.split("/")?.[1]?.toUpperCase() ?? item.type.toUpperCase()
    : "";

  return (
    <div className="p-2">
      <div className="group relative rounded-xl border border-wa-border bg-wa-panel p-3 shadow-[0_16px_40px_-34px_rgba(0,0,0,0.5)] transition hover:border-wa-accent/35 hover:bg-wa-panel2/90">
        <div className="absolute right-2 top-2 z-10 flex items-center gap-1">
          <a
            href={item?.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex h-8 w-8 items-center justify-center rounded-md text-wa-accent transition hover:bg-wa-hover"
            title="Download"
          >
            <DocumentArrowDownIcon className="h-5 w-5" />
          </a>
          {userdetails?.role_id == 2 && (
            <button
              type="button"
              onClick={() => deleteDocument(item)}
              className="inline-flex h-8 w-8 items-center justify-center rounded-md text-rose-400 transition hover:bg-wa-hover hover:text-rose-500"
              title="Verwijderen"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          )}
        </div>

        <div className="flex min-h-[104px] items-start gap-3 pr-16">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg border border-wa-border bg-wa-panel2">
            <FontAwesomeIcon
              icon={typeFile(item?.type)}
              className="h-9 w-9 text-wa-muted"
            />
          </div>
          <div className="min-w-0">
           {/*  <p
              className="line-clamp-2 text-sm font-semibold leading-snug text-wa-text"
              title={item?.title || "Geen titel"}
            >
              {item?.title || "Geen titel"}
            </p> */}
            <p
              className="mt-1 line-clamp-2 break-all text-sm text-wa-muted"
              title={item?.bestand}
            >
              {item?.bestand}
            </p>
            <span className="mt-2 inline-flex rounded-md border border-wa-border bg-wa-panel2 px-2 py-1 text-[11px] font-semibold uppercase tracking-wide text-wa-muted">
              {fileTypeLabel || "Bestand"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileCard;
